module.exports = __webpack_public_path__ + "static/Icons_ReverseMortgage_Large-df25d1ae794f6f377c729dba1ea78422.png";